export const PHONE_NUMBER = '+30 693 717 8000';

export const EMAIL = 'info@boxnow.gr';
